import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@core/services/auth-service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Attend l'initialisation unique de l'auth (checkAuth + profil/rôles) au lieu
  // d'appeler checkAuth() séparément — un second appel concurrent pendant le
  // traitement du callback OIDC de login peut perturber l'échange en cours et
  // laisser les rôles vides (voir roles-guard.ts).
  await authService.initialize();

  const isAuthenticated = await firstValueFrom(authService.isAuthenticated$);
  return isAuthenticated ? true : router.createUrlTree(['/login']);
};
